<template>
  <!-- 视频素材上传 -->
  <div style="background-color: #f5f5f5; margin-top: 0.7rem">
    <div class="material_upload comBox">
      <div class="left">
        <leftTemplate :left_tabShow="'material_upload'"></leftTemplate>
      </div>
      <div class="right">
        <leftTemplate2
          @tabClick="tabClick"
          :top_tabShow="top_type"
        ></leftTemplate2>
        <div v-if="list.length == 0">
          <button
            @click="click"
            @dragover.prevent
            @drop="handleDrop"
            style="background: #fff; border: none; width: 100%"
          >
            <div
              class="el-upload__text"
              style="
                display: flex;
                flex-direction: column;
                height: 100%;
                margin-top: 1.3rem;
              "
            >
              <div class="upload_1">
                {{
                  top_type == "VIDEO"
                    ? "拖拽视频/模版文件到此处开始上传"
                    : top_type == "MUSIC"
                    ? "拖拽音乐文件到此处开始上传"
                    : "拖拽图片格式文件到此处开始上传"
                }}
              </div>
              <div class="upload_2">点击选择文件</div>
              <div class="upload_3">
                {{
                  top_type == "VIDEO"
                    ? "建议上传720P-8K的专业横屏、竖屏视频文件，文件小于8G"
                    : top_type == "MUSIC"
                    ? "仅限WAV、MP3格式，时长>15S，采样≥44.1KHZ，位速率 1411KBPS"
                    : "建议上传jpg、png、psd等格式图片，宽*高≥600万像素"
                }}
              </div>
            </div>
          </button>
        </div>
        <div class="my_debit_right_box" v-if="list.length != 0">
          <div style="margin-top: 0.02rem; display: flex; height: 14px">
            <div>
              <span
                @click="selectAll"
                v-if="!allCheckbox"
                class="el-checkbox__inner_zd"
              ></span>
              <span
                @click="selectAll"
                v-if="allCheckbox"
                class="el-checkbox__inner_select"
              ></span>
              <span style="margin-top: -10px; margin-left: 5px; color: #666"
                >全选</span
              >
            </div>
          </div>
          <div style="display: flex">
            <div class="topBtn" @click="handleDelBtn">批量删除</div>
            <div
              class="topBtn"
              @click="click"
              style="background-color: #ff6000; color: #fff"
            >
              继续上传
            </div>
          </div>
        </div>
        <el-table
          ref="multipleTableRef"
          :data="list"
          :row-key="getHolidayRowKey"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          height="550"
          v-show="list.length != 0"
        >
          <el-table-column type="selection" width="55" reserve-selection="true"/>
          <el-table-column property="name" label="商品信息">
            <template #default="scope">
              <div style="display: flex">
                <div style="" class="table_img">
                  <el-image
                    style="width: 100%; height: 100%; border-radius: 10px"
                    :zoom-rate="1.2"
                    :preview-src-list="[
                      scope.row.showImage && scope.row.showImage,
                    ]"
                    :initial-index="4"
                    fit="cover"
                  >
                    <template #error>
                      <div class="image-slot" style="width: 100%; height: 100%">
                        <img
                          style="width: 100%; height: 100%"
                          :src="
                            scope.row.showImage
                              ? scope.row.showImage
                              : require('../../../assets/img/noImg.png')
                          "
                        />
                      </div>
                    </template>
                  </el-image>
                </div>
                <div class="table_information">
                  <div
                    style="
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                    "
                  >
                    {{ scope.row.title }}.{{ scope.row.fileExt }}
                  </div>
                  <div v-if="scope.row.id">
                    <div v-if="scope.row.percentage">
                      {{
                        formatSize(
                          scope.row.size * (scope.row.percentage / 100)
                        )
                      }}/{{ formatSize(scope.row.size) }}
                    </div>
                    <div v-else>
                      {{ scope.row.fileSize }}
                    </div>
                  </div>
                  <div v-else>
                    {{
                      formatSize(scope.row.size * (scope.row.progress / 100))
                    }}/{{ formatSize(scope.row.size) }}
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            property="type"
            label="上传进度"
            width="240"
            align="center"
          >
            <template #default="scope">
              <div
                v-if="
                  (!!scope.row.progress && scope.row.progress == 100) ||
                  scope.row.id
                "
              >
                <div style="color: #4bc185; text-align: center">
                  请完善信息后提交审核
                </div>
              </div>
              <div v-else>
                <el-progress
                  :percentage="scope.row.progress"
                  :show-text="false"
                />
                <div style="display: flex; justify-content: space-between">
                  <div>
                    已上传<span style="color: #3fa4ed"
                      >{{ scope.row.progress }}%</span
                    >
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="190" align="center">
            <template #default="scope">
              <div style="display: flex">
                <div
                  style="width: 100px; cursor: pointer"
                  class="topBtn"
                  v-if="!scope.row.zipStatus"
                >
                  {{
                    (scope.row.progress && scope.row.progress < 100) ||
                    scope.row.progress == 0
                      ? "上传中"
                      : "解析中"
                  }}
                </div>
                <div
                  style="width: 100px; cursor: pointer"
                  class="topBtn"
                  v-if="scope.row.zipStatus == 2"
                >
                  解析失败
                </div>
                <div
                  style="width: 100px; cursor: pointer"
                  class="topBtn"
                  @click="handlePerfect(scope.$index, scope.row)"
                  v-if="scope.row.zipStatus"
                >
                  完善信息
                </div>
                <div
                  v-if="
                    (scope.row.progress && scope.row.progress == 100) ||
                    (!scope.row.progress && scope.row.progress != 0)
                  "
                  @click="handleDel(scope.$index, scope.row)"
                  style="
                    color: #ff2929;
                    margin-left: 0.1rem;
                    line-height: 0.43rem;
                    cursor: pointer;
                  "
                >
                  删除
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          v-if="list.length != 0"
          v-model:current-page="page.pageNum"
          v-model:page-size="page.pageSize"
          @size-change="sizeChange"
          @current-change="currentChange"
          style="margin: 0.4rem 0"
          background
          layout="prev, pager, next"
          :total="page.total"
        />
      </div>
    </div>
    <!-- 删除 -->
    <el-dialog
      title=""
      v-model="dialogDelVisible"
      align-center
      width="480px"
      :close-on-click-modal="false"
    >
      <div style="width: 0.4rem; height: 0.4rem; margin: 0 auto">
        <img
          style="100%;height: 100%;"
          src="@/assets/img/tips／exclamation-circle-fill@2x.png"
        />
      </div>

      <div style="text-align: center; font-size: 0.16rem; margin: 0.16rem 0">
        删除后则无法恢复，是否继续？
      </div>
      <div style="display: flex; justify-content: center">
        <div class="dataBtnClose" @click="dialogDelVisible = false">取消</div>
        <div class="dataBtnSubmit" @click="delSubmit">确认</div>
      </div>
    </el-dialog>
    <input
      class="layout-file"
      style="height: 0px"
      type="file"
      @change="handleFileChange"
      ref="inputer"
      multiple
      :accept="allowedExtensions.join(',')"
    />
  </div>
</template>

<script setup>
import leftTemplate from "@/components/leftTemplate1.vue";
import leftTemplate2 from "@/components/leftTemplate2.vue";

import { ref, computed, onUnmounted, onMounted } from "vue";
import { Axios } from "../../../assets/js/ls_com_axios.js";
import { serverUrls } from "../../../assets/js/ls_tgServerUrls.js";
import { serverBaseUrl } from "../../../assets/js/ls_tgServerUrls.js";
import { useRoute, useRouter } from "vue-router";
import { ElMessage, ElTable } from "element-plus";
import { useStore } from "vuex";
const store = useStore();
let pageDef = ref({
  pageNum: 1,
  pageSize: 6,
  total: 0,
});
const page = pageDef;
const router = useRouter();
const route = useRoute();
var fileList = ref([]); // 创建一个空数组
var uploadList = computed(() => {
  console.info(store.state.uploadList);
  return store.state.uploadList;
});
const isTableLoading = ref(false);
let timer = null;
let dialogDelVisible = ref(false);
const multipleTableRef = ref();
const multipleSelection = ref([]);
const getHolidayRowKey = (row)=>{
  return row.id || row.guid;
}
let idArray = ref([]);
const handleSelectionChange = (val) => {
  console.info(val)
  multipleSelection.value = val;
  if (multipleSelection.value.length == list.value.length) {
    allCheckbox.value = true;
  } else {
    allCheckbox.value = false;
  }
  idArray.value = multipleSelection.value.map((obj) => obj.id || obj.guid);
};
let allCheckbox = ref(false);
const formatSize = (size) => {
  if (size < 0) return "Invalid Size";

  const units = ["B", "KB", "MB", "GB", "TB"];
  let index = 0;
  while (size >= 1024 && index < units.length - 1) {
    size /= 1024;
    index++;
  }

  return `${parseFloat(size.toFixed(2))} ${units[index]}`;
};
let materialType = ref(localStorage.getItem("scsc") || "VIDEO");
//点击
const top_type = computed({
  get: () => {
    return materialType.value;
  },
  set: (v) => {
    materialType.value = v;
    localStorage.setItem("scsc", v);
  },
});
const allowedExtensions = computed(() => {
  if (top_type.value == "VIDEO") {
    return [".mp4", ".mov", ".prproj", ".aep", ".c4d", ".rar", ".zip"];
  } else if (top_type.value == "MUSIC") {
    return [".mp3", ".wav"];
  } else {
    return [".bmp", ".gif", ".jpg", ".jpeg", ".png", ".psd", ".rar", ".zip"];
  }
});
const tabClick = (res) => {
  page.value.pageNum = 1;
  allCheckbox.value = false;
  top_type.value = res;
  init();
};
const list = computed(() => {
  return uploadList.value
    .filter((x) => x.materialType === top_type.value)
    .concat(fileList.value);
});
//删除数组
const handleDel = (index, row) => {
  console.log("row.id", row.id);
  if (row.id) {
    idArray.value = [row.id];
    dialogDelVisible.value = true;
  } else {
    // 停止上传逻辑
    stopUpload(row.guid);
    fileList.value.splice(index, 1);
  }
};

// 停止上传函数
const stopUpload = (guid) => {
  const index = uploadList.value.findIndex((f) => f.guid === guid);
  if (index !== -1) {
    // 处理停止上传逻辑
    uploadList.value[index].isUploading = false; // 假设你有一个标志来控制上传状态
    store.commit("updateUpload", { index, item: uploadList.value[index] });
  }
};
// const allCheckbox = ref(false);
const selectAll = () => {
  allCheckbox.value = !allCheckbox.value;
  if (allCheckbox.value) {
    list.value.forEach((item) => {
      multipleTableRef.value.toggleRowSelection(item, true);
    });
  } else {
    list.value.forEach((item) => {
      multipleTableRef.value.toggleRowSelection(item, false);
    });
  }
};
// 批量删除按钮点击事件
const handleDelBtn = () => {
  console.log(multipleSelection.value);
  if (multipleSelection.value.length > 0) {
    idArray.value = multipleSelection.value.map((item) => item.id || item.guid);
    dialogDelVisible.value = true;
  } else {
    ElMessage({
      message: "请选择文件",
      type: "error",
    });
  }
};

// 删除确认提交
const delSubmit = () => {
  if (idArray.value.length > 0) {
    const idsToDelete = idArray.value.filter((id) => typeof id === "number");
    const guidsToStop = idArray.value.filter((id) => typeof id === "string");

    // 停止上传逻辑
    guidsToStop.forEach((guid) => stopUpload(guid));

    if (idsToDelete.length > 0) {
      Axios(
        "delete",
        `/fodder/manage/remove/${idsToDelete}`,
        {},
        false,
        (res) => {
          if (res.data.code == 200) {
            dialogDelVisible.value = false;
            isTableLoading.value = false;
            init();
            if (timer) {
              clearTimeout(timer);
              timer = null;
            }
            if (ids) {
              for (let index = 0; index < ids.length; index++) {
                const element = ids[index];
                if (idArray.value.indexOf(element) != -1) {
                  ids.splice(index, 1);
                }
              }
            }
            // 从 uploadList 和 fileList 中移除已删除的文件
            idArray.value.forEach((id) => {
              const uploadIndex = uploadList.value.findIndex(
                (item) => item.id === id || item.guid === id
              );
              if (uploadIndex !== -1) {
                store.commit("removeUpload", uploadIndex);
              }
              const fileIndex = fileList.value.findIndex(
                (item) => item.id === id || item.guid === id
              );
              if (fileIndex !== -1) {
                fileList.value.splice(fileIndex, 1);
              }
            });
            ElMessage({
              message: "删除成功",
              type: "success",
            });
          } else {
            ElMessage({
              message: "删除错误",
              type: "error",
            });
          }
        }
      );
    } else {
      // 仅有上传中的文件需要删除
      idArray.value.forEach((id) => {
        const uploadIndex = uploadList.value.findIndex(
          (item) => item.guid === id
        );
        if (uploadIndex !== -1) {
          store.commit("removeUpload", uploadIndex);
        }
        const fileIndex = fileList.value.findIndex((item) => item.guid === id);
        if (fileIndex !== -1) {
          fileList.value.splice(fileIndex, 1);
        }
      });
      dialogDelVisible.value = false;
      init();
      ElMessage({
        message: "删除成功",
        type: "success",
      });
    }
  } else {
    ElMessage({
      message: "请选择文件",
      type: "error",
    });
  }
};
const init = () => {
  let paramsA = {
    materialType: top_type.value,
    pageNum: page.value.pageNum,
    pageSize: page.value.pageSize,
    orderByColumn: "createTime",
    isAsc: "desc",
    status: 1,
  };
  Axios("get", "/fodder/manage/my-list", paramsA, false, function (res) {
    if (uploadList.value.length > 0) {
      uploadList.value.forEach((element, index) => {
        if (
          element.progress == 100 &&
          element.materialType === top_type.value
        ) {
          store.commit("removeUpload", index);
        }
      });
    }
    fileList.value = res.data.rows;
    page.value.total = res.data.total;
  });
};
init();

//完善上传
const handlePerfect = (index, row) => {
  // IMAGE, MUSIC, VIDEO
  if (row.materialType == "VIDEO") {
    router.push({
      path: "/materiaPerfect",
      query: {
        id: row.id,
      },
    });
  } else if (row.materialType == "MUSIC") {
    router.push({
      path: "/musicPerfect",
      query: {
        id: row.id,
      },
    });
  } else if (row.materialType == "IMAGE") {
    router.push({
      path: "/picturePerfect",
      query: {
        id: row.id,
      },
    });
  }
};

/**
 * 分片上传
 */
import uploadByPieces from "@/assets/js/uploadNew";
const inputer = ref(null);
const click = () => {
  inputer.value.value = "";
  inputer.value.click();
};
const handleDrop = (event) => {
  event.preventDefault();
  console.log("event", event); // Accessing event object inside the function

  const files = event.dataTransfer.files;
  const fileArray = Array.from(files);

  // Call handleFileChange and pass files array as an argument
  handleFileChange(fileArray);
};

const ids = [];
const handleFileChange = (fileArray) => {
  const timestamp = Date.now();
  let files = []; // 将 const 改为 let
  if (fileArray && Array.isArray(fileArray)) {
    files = fileArray;
  } else {
    files = Array.from(inputer.value.files);
  }
  files.forEach((file) => {
    if (
      allowedExtensions.value.indexOf(
        file.name.substring(file.name.lastIndexOf(".")).toLocaleLowerCase()
      ) == -1
    ) {
      ElMessage.warning("格式不正确");
      return;
    }
    // return console.log(file);
    const fileName = file.name;
    const guid = newGuid();
    const fileData = {
      guid: guid,
      progress: 0,
      materialType: top_type.value,
      size: file.size,
      title: fileName.substring(0, fileName.lastIndexOf(".")),
      fileExt: fileName.substring(fileName.lastIndexOf(".") + 1),
      isUploading: true, // 添加上传状态标志
    };
    store.commit("addUpload", fileData);
    uploadByPieces(
      timestamp,
      file,
      5,
      3,
      (res) => {
        const index = uploadList.value.findIndex((f) => f.guid === guid);
        if (index !== -1 && uploadList.value[index].isUploading) {
          // 处理上传成功逻辑
          const params = {
            title: fileName.substring(0, fileName.lastIndexOf(".")),
            fileExt: fileName.substring(fileName.lastIndexOf(".") + 1),
            filePath: res.data.url,
            materialType: uploadList.value[index].materialType,
          };
          Axios("post", "/fodder", params, false, (resp) => {
            if (resp.data.code !== 200) {
              ElMessage.error(res.data.msg);
            } else {
              ids.push(resp.data.data.id);
              const item = JSON.parse(JSON.stringify(uploadList.value[index]));
              item.id = resp.data.data.id;
              store.commit("updateUpload", { index, item });
              setTimeout(() => {
                loadNewInfo();
              }, 3000);
            }
          });
        }
      },
      (p) => {
        const index = uploadList.value.findIndex((f) => f.guid === guid);
        if (index !== -1 && uploadList.value[index].isUploading) {
          const item = JSON.parse(JSON.stringify(uploadList.value[index]));
          item.progress = p;
          store.commit("updateUpload", { index, item });
        }
      },
      (error) => {
        console.error(error);
      }
    );
  });
};
const newGuid = () => {
  let guid = "";
  for (let i = 1; i <= 32; i++) {
    const n = Math.floor(Math.random() * 16.0).toString(16);
    guid += n;
    if (i === 8 || i === 12 || i === 16 || i === 20) guid += "-";
  }
  return guid;
};
/**
 * 分页
 * sizeChange
 * currentChange
 * prevClick
 * nextClick
 *
 */
const sizeChange = (val) => {
  init();
};
const currentChange = (val) => {
  page.value.pageNum = val;
  init();
};
const prevClick = (val) => {
  page.value.pageNum = val;
  init();
};
const nextClick = (val) => {
  page.value.pageNum = val;
  init();
};
const loadNewInfo = () => {
  if (timer) {
    clearTimeout(timer);
    timer = null;
  }
  if (ids.length > 0) {
    ids.forEach((a, i) => {
      Axios(
        "get",
        "/fodder/info/" + a,
        {},
        false,
        function (res) {
          if (res.data.data.zipStatus == 1) {
            let index = uploadList.value.findIndex((x) => x.id == a);
            if (index != -1) {
              const item = res.data.data;
              item.progress = 100;
              store.commit("updateUpload", { index, item });
            }
            ids.splice(i, 1);
          }
        },
        function (res) {
          ids.splice(i, 1);
          let index = uploadList.value.findIndex((x) => x.id == a);
          if (index != -1) store.commit("removeUpload", index);
        }
      );
    });
    timer = setTimeout(() => {
      loadNewInfo();
    }, 10000);
  }
};
onUnmounted(() => {
  if (timer) {
    clearTimeout(timer);
    timer = null;
  }
});
</script>

<style scoped>
@import url(/src/assets/css/left_right.css);
@import url(/src/assets/css/com.css);

.material_upload {
  display: flex;
  margin: 0 auto;
}

.upload_1 {
  font-size: 0.32rem;
  color: #86909c;
  text-align: center;
  margin-bottom: 0.32rem;
}

.upload_2 {
  width: 2.04rem;
  height: 0.53rem;
  background: #c01a26;
  border-radius: 0.12rem 0.12rem 0.12rem 0.12rem;
  opacity: 1;
  text-align: center;
  color: #fff;
  line-height: 0.53rem;
  margin: 0 auto 0.16rem;
  cursor: pointer;
}

.upload_3 {
  font-size: 0.12rem;
  color: #86909c;
  text-align: center;
  margin-bottom: 2rem;
}

/deep/.el-upload-dragger {
  border: none;
}

/* 表格 */
.material_complete {
  display: flex;
  margin: 0 auto;
}

.my_debit_right_box {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0.2rem 0.17rem;
  box-sizing: border-box;
  vertical-align: middle;
  background-color: #f2f3f5;
}

.my_debit {
  background-color: #f5f5f5;
  overflow: hidden;
  width: 100%;
}

.topBtn {
  font-size: 0.14rem;
  padding: 0.08rem 0.16rem;
  text-align: center;
  color: #333333;
  background: #ffffff;
  border-radius: 0.2rem;
  opacity: 1;
  border: 0.01rem solid #e5e6eb;
  margin-left: 0.2rem;
  cursor: pointer;
}

.table_img {
  background-color: #3fa4ed;
  width: 1rem;
  height: 0.6rem;
  background: #d9d9d9;
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  opacity: 1;
  margin-right: 0.1rem;
}

.table_information {
  width: calc(100% - 1rem - 0.1rem);
  height: 0.6rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

/deep/ .el-table th.el-table__cell.is-leaf {
  background: #e3e6ec !important;
}

/deep/th .cell .el-checkbox__input {
  display: none;
}

/deep/.el-checkbox.el-checkbox--large {
  height: 0.2rem !important;
}

/deep/.el-dialog.is-align-center {
  border-radius: 20px !important;
}

/* 分页 */

.el-pagination {
  justify-content: center;
}

/deep/.el-pager li {
  padding: 0.06rem;
  margin: 0 0.03rem;
}

/deep/.el-pager li.is-active {
  color: #fff;
  background: #c01a26;
}

/deep/.el-pager li:hover {
  color: #fff;
  background: #c01a26;
}

/deep/ .el-pagination.is-background .el-pager li.is-active {
  background: #c01a26;
}

/deep/.el-popper:focus {
  outline: none !important;
}

/* 全选自定义 */
.el-checkbox__inner_zd {
  width: 14px;
  height: 14px;
  display: inline-block;
  position: relative;
  border: 1px solid #ccc;
  border-radius: 2px;
  box-sizing: border-box;
  /* width: var(--el-checkbox-input-width);
		height: var(--el-checkbox-input-height); */
  background-color: #fff;
  z-index: var(--el-index-normal);
  transition: border-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46),
    background-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46),
    outline 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46);
}

.el-checkbox__inner_select::after {
  box-sizing: content-box;
  content: "";
  border: 1px solid transparent;
  border-left: 0;
  border-top: 0;
  height: 7px;
  left: 4px;
  position: absolute;
  top: 1px;
  transform: rotate(45deg) scaleY(0);
  width: 3px;
  transition: transform 0.15s ease-in 50ms;
  transform-origin: center;
  transform: rotate(45deg) scaleY(1);
  border-color: var(--el-checkbox-checked-icon-color);
}

.el-checkbox__inner_select {
  width: 14px;
  height: 14px;
  display: inline-block;
  position: relative;
  border: 1px solid #c01a26;
  border-radius: 2px;
  box-sizing: border-box;
  color: #fff;
  background-color: #c01a26;
  z-index: var(--el-index-normal);
  transition: border-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46),
    background-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46),
    outline 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46);
}
</style>
